import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth-routes/admin/pnlRows')({
  beforeLoad: () => {
    throw redirect({ to: '/admin/pnlRow' })
  },
})
